const RuntimeConfig = {
  siteUrl: window?.location?.origin || "",
  discordOauthClientId: import.meta.env.VITE_DISCORD_OAUTH_CLIENT_ID,
  discordBotPermissions: import.meta.env.VITE_DISCORD_BOT_PERMISSIONS,
  discordAdditionalOauthClientIds: (import.meta.env.VITE_DISCORD_ADDITIONAL_OAUTH_CLIENT_IDS || "")
    .split(",")
    .filter(Boolean),
  debugDiscordUserIds: (import.meta.env.VITE_DISCORD_DEBUG_USER_IDS || "")
    .split(",")
    .filter(Boolean),
};

export const useRuntimeConfig = () => RuntimeConfig;
